import Header from './components/Header/Header.jsx';
import HeroSection from './components/HeroSection/HeroSection.jsx';
import AboutSection from './components/AboutSection/AboutSection.jsx';
import ContactForm from './components/ContactForm/ContactForm.jsx';
import MapSection from './components/MapSection/MapSection.jsx';
import MenuSection from './components/MenuSection/MenuSection.jsx';
import GallerySection from './components/GallerySection/GallerySection.jsx';
import Footer from './components/Footer/Footer.jsx';


// app.js file

function App() {
  return (
    <>
      <Header />
      <HeroSection />
      <AboutSection />
      <MenuSection />
      <GallerySection />
      <ContactForm />
      <MapSection />
      <Footer />
    </>
  );
}
export default App;
